import { render, staticRenderFns } from "./BusinessAmountCard.vue?vue&type=template&id=01e99a23"
import script from "./BusinessAmountCard.vue?vue&type=script&lang=js"
export * from "./BusinessAmountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports